import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;

  if(value >= 96) {
    return { 
      title: 'ระดับออกซิเจนปกติ',
      color: 'green',
      caption: 'ระดับออกซิเจนในเลือดปกติ',
      suggest: ''
    };
  } else {
    return { 
      title: 'ระดับออกซิเจนในเลือดต่ำกว่าปกติ',
      color: 'red',
      caption: 'ระดับออกซิเจนในเลือดต่ำกว่าปกติ',
      suggest: 'ควรไปพบแพทย์'
    };
  }

}